// Import all page-critical images so webpack resolves them to their final hashed URLs.
// These are then grouped by route so the preloader knows exactly what to fetch.

// Home page
import homeHero  from "../assets/abbie-1.jpg";
import homeAbout from "../assets/abbie-2.jpg";
import h1 from "../assets/home/4c0d9f486aef5998d0fef3b8f6ab8d.jpg";
import h2 from "../assets/home/IMG_3148.jpg";
import h3 from "../assets/home/IMG_3151.jpg";
import h4 from "../assets/home/IMG_3152.jpg";
import h5 from "../assets/home/IMG_3153.jpg";
import h6 from "../assets/home/b1fc412a376ddf3deb585afe7fce59.jpg";

// Contact page
import p1 from "../assets/photos/bfe94595297c00f40748278838968c.JPG";
import p2 from "../assets/photos/851995094751bd9962be7e2944827a2c.JPG";
import p3 from "../assets/photos/DSCF8115.JPG";
import p4 from "../assets/photos/DSCF6910 2.JPG";
import p5 from "../assets/photos/IMG_8815.JPG";
import { preloadProjectsData } from "./projectsData";

/** Map of route path → list of image URLs to preload */
const ROUTE_ASSETS = {
  "/":        [homeHero, homeAbout, h1, h2, h3, h4, h5, h6],
  "/contact": [p1, p2, p3, p4, p5],
  "/projects": [],
};

const ROUTE_WARMUPS = {
  "/projects": preloadProjectsData,
};

/**
 * Preload an array of image URLs by creating off-screen Image objects.
 * Resolves when all images finish loading (or error out — we don't block on failures).
 * Has a hard timeout of `maxMs` so a slow image never delays the page.
 */
export function preloadImages(urls, maxMs = 1800) {
  if (!urls || urls.length === 0) return Promise.resolve();

  const loads = urls.map(
    (url) =>
      new Promise((resolve) => {
        const img = new Image();
        img.onload  = resolve;
        img.onerror = resolve; // don't block on failed loads
        img.src = url;
      }),
  );

  const timeout = new Promise((resolve) => setTimeout(resolve, maxMs));
  return Promise.race([Promise.all(loads), timeout]);
}

/**
 * Fire-and-forget: preload assets for a given route.
 * Safe to call multiple times — browser caches the responses.
 */
export function preloadRoute(path) {
  const urls = ROUTE_ASSETS[path] ?? [];
  const warmup = ROUTE_WARMUPS[path];

  void preloadImages(urls);
  if (warmup) warmup();
}
